module.exports = __webpack_public_path__ + "img/puzzle.ae714299.svg";